module.exports = __webpack_public_path__ + "img/Airbnb-Working-In-Groups-Zoom-Meeting-1.c899274b.jpg";